export default __webpack_public_path__ + "static/BasierCircle-Italic-a1057153340e5ac90b32e5fd58022902.woff";